export const publics = [
    {
        name: "Masjid Al-Ikhlas Pasir Waringin",
        position: [-7.407845760417268, 106.98530316352846],
        icon: 'mosque',
    },
    {
        name: "Masjid Nurul Muchtar Agrabinta",
        position: [-7.417341222617866, 106.8990057706833],
        icon: 'mosque',
    },
    {
        name: "Masjid Nurul Huda",
        position: [-7.407021214825374, 106.98960542678834],
        icon: 'mosque',
    },
    {
        name: "Pertamina Mini Pasir Bayur",
        position: [-7.410675801938678, 106.982342004776],
        icon: 'gas-station',
    },
];